/**
 * Lucide icons by manifest name (kebab-case). A curated map keeps the bundle
 * small (importing every Lucide icon would add hundreds of KB). A module
 * whose manifest names an icon missing here gets the neutral fallback;
 * ask WP0-SHELL to add it (docs/requests/).
 */
import {
  Activity,
  BadgePercent,
  BarChart3,
  Bell,
  BookOpenText,
  BriefcaseBusiness,
  Building2,
  CalendarDays,
  CircleDollarSign,
  CircleHelp,
  ClipboardList,
  Clock,
  Command,
  CreditCard,
  Download,
  EyeOff,
  FileText,
  FlaskConical,
  FolderOpen,
  Gauge,
  Image,
  Inbox,
  Info,
  Keyboard,
  KeyRound,
  Layers,
  LayoutDashboard,
  Lightbulb,
  ListChecks,
  Lock,
  MessageSquare,
  Monitor,
  Moon,
  Phone,
  Pill,
  Radio,
  Package,
  Receipt,
  RefreshCw,
  RotateCcw,
  ScanLine,
  Search,
  Send,
  Settings,
  Shield,
  ShieldCheck,
  Smile,
  Sparkles,
  Star,
  Stethoscope,
  Store,
  Sun,
  TrendingUp,
  UserPlus,
  UserRound,
  Users,
  UsersRound,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export const ICONS: Readonly<Record<string, LucideIcon>> = {
  activity: Activity,
  'badge-percent': BadgePercent,
  'bar-chart-3': BarChart3,
  'chart-column': BarChart3,
  bell: Bell,
  'building-2': Building2,
  calendar: CalendarDays,
  'calendar-days': CalendarDays,
  'circle-dollar-sign': CircleDollarSign,
  'book-open-text': BookOpenText,
  'circle-help': CircleHelp,
  'clipboard-list': ClipboardList,
  'briefcase-business': BriefcaseBusiness,
  clock: Clock,
  command: Command,
  'credit-card': CreditCard,
  'eye-off': EyeOff,
  'file-text': FileText,
  'flask-conical': FlaskConical,
  'folder-open': FolderOpen,
  gauge: Gauge,
  image: Image,
  inbox: Inbox,
  info: Info,
  keyboard: Keyboard,
  'key-round': KeyRound,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  lightbulb: Lightbulb,
  'list-checks': ListChecks,
  lock: Lock,
  'message-square': MessageSquare,
  monitor: Monitor,
  download: Download,
  moon: Moon,
  phone: Phone,
  pill: Pill,
  radio: Radio,
  package: Package,
  receipt: Receipt,
  'rotate-ccw': RotateCcw,
  'refresh-cw': RefreshCw,
  'scan-line': ScanLine,
  search: Search,
  send: Send,
  settings: Settings,
  shield: Shield,
  'shield-check': ShieldCheck,
  smile: Smile,
  sparkles: Sparkles,
  star: Star,
  stethoscope: Stethoscope,
  store: Store,
  sun: Sun,
  'trending-up': TrendingUp,
  'user-plus': UserPlus,
  'user-round': UserRound,
  users: Users,
  'users-round': UsersRound,
  wallet: Wallet,
};

export function iconFor(name: string | undefined): LucideIcon {
  return (name ? ICONS[name] : undefined) ?? CircleHelp;
}

export function Icon({
  name,
  size = 16,
  className,
}: {
  name: string | undefined;
  size?: number;
  className?: string;
}) {
  const C = iconFor(name);
  return <C size={size} strokeWidth={1.75} aria-hidden className={className} />;
}
